module.exports = __webpack_public_path__ + "static/media/inbox.e8596628.svg";